//USER IDS WHICH WE WANT TO BLOCK ACCESS
const blockedIds = [
  570, 582, 625, 1006, 1633, 1844, 1900, 1904, 1932, 1933, 2142,
];

export const redirectToHomePage = (userId) => {
  const userIdMatch = blockedIds.findIndex((val) => val === userId);
  return userIdMatch === -1 ? false : true;
};
